import React from "react";
import { Modal, Col } from "reactstrap";
import { CustomButton } from "../home/main/home-layout-draggable-columns/custom-button";
import WarningIcon from "./items/WarningIcon";

export const ModalPublishAlert = ({
  onCancel,
  isOpen,
  title = "Theme published successfully",
  message = "Your home theme is now live in the production app. Open or refresh the app to see the changes. Tip: collection changes are saved from the Collections page (Save) — they do not need Publish.",
}) => (
  <Modal isOpen={isOpen} className="modal-dialog-centered confirm-remove-modal">
    <div className="publish-modal-header">
      <div>
        <WarningIcon />
      </div>
      <div className="publish-modal-message">
        <strong>{title}</strong>
        <div style={{ marginTop: 8 }}>{message}</div>
      </div>
    </div>
    <div className="publish-modal-buttons">
      <Col xs="14">
        <CustomButton type="SAVE" onClick={onCancel} label="OK" />
      </Col>
    </div>
  </Modal>
);
